import React, { Component } from 'react';
import { connect } from 'react-redux';
import "react-datepicker/dist/react-datepicker.css";
import { ANY_ERROR } from '../../../action/user_action_types';
import http from '../../../util/http';

class ExcelPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {    
      campaignData: []
    }
  }



  render() {
    let { campaignData } = this.state;   
    // let { audioBrief } = campaignData;

    // console.log('audioBrief',campaignData);
    // console.log('audioBriefaudioBrief',audioBrief);


    return (
      <div>
        <div className="modal-overlay">
          <div className="modal-wrapper thankyou-popup" aria-modal aria-hidden tabIndex={-1} role="dialog">
            <div className="modal">
              <div className="modal-head-cross rate-modal">
                <button type="button" className="modal-close-button" onClick={() => this.props.hideExcelPopup()}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="editNonFct-modal modal-body">
                  <div className="bg-white">
                    <form className="form-group">
                      <div className="popupCampaign-container">
                        <div className="campaign-input master-inputs nonFct">

                        <div className="camplist_data">
                          {/* <span className="camplist_head"> AUDIO BRIEF</span> */}
                          <span className="camplist_name">{this.state.campaignData.audioBrief}</span>
                      </div>
                        
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    showError: error => dispatch({
      type: ANY_ERROR,
      payload: error
    })
  }
}

export default connect(null, mapDispatchToProps)(ExcelPopup);



// WEBPACK FOOTER //
// ./web/components/admin/audioadminmanagment/ExcelPopup.jsx